import Typekey from '@/userManagement/Typekey';

export default class StatusType extends Typekey {
  static readonly approved = new StatusType('approved', 'Approved', '');

  static readonly draft = new StatusType('draft', 'Draft', '');

  static readonly waitingForApproval = new StatusType('waitingForApproval', 'Waiting For Approval', '');

  static readonly rejected = new StatusType('rejected', 'Rejected', '');

  static readonly deleted = new StatusType('deleted', 'Deleted', '');

  static readonly reported = new StatusType('reported', 'Reported', '');

  static readonly active = new StatusType('active', 'Active', '');

  static allStatusTypes() {
    return [
      StatusType.draft,
      StatusType.waitingForApproval,
      StatusType.approved,
      StatusType.rejected,
      StatusType.reported,
      StatusType.deleted,
      StatusType.active,
    ];
  }
}
